import React from 'react';
import styled from 'styled-components';
import { Container as _Container, Typo, Buttons } from 'tmt-ui-kit';
// import { scroller, Element } from 'react-scroll';

import RehydrateComponent from '~/components/RehydrateComponent';
import HeadTag from '~/components/Head/HeadTag';
import Register from '~/components/Influencer/Register';
import Detail from '~/components/Influencer/Detail';
import Element from '~/components/Scroll/Element';
import useWindowSize from '~/utils/hooks/use-window-size';
import scrollTo from '~/utils/scroller';

const Container = styled(_Container.InnerContainer)`
  z-index: 1;
  width: 100%;
  padding-bottom: 80px;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 2%;

  @media(max-width: 768px) {
    grid-template-columns: 1fr;
  }

  @media(max-width: 600px) {
    ${props => props.content && 'padding: 0px;'}
    padding-bottom: 50px;
  }
`;

const Banner = styled.div`
  position: relative;
  height: 400px;
  display: flex;
  flex-direction: column;
  background: url('/static/images/Influencer/banner.jpg');
  background-size: cover;
  background-position: center;

  @media(max-width: 600px) {
    display: flex;
    justify-content: flex-end;
    background: url('/static/images/Affiliate/mobile-banner.jpg');
    background-size: cover;
    background-position: center;
    height: 570px;
  }
`;

const BannerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(80deg, white 40%, rgba(0, 0, 0, .0) 55%) no-repeat;
  background-size: cover;
  background-position: left;

  @media(max-width: 768px) {
    background: linear-gradient(80deg, white 55%, rgba(0, 0, 0, .0) 67%) no-repeat;
  }
  @media(max-width: 600px) {
    background: linear-gradient(to top, white 30%, rgba(0, 0, 0, .0) 67%) no-repeat;
    background-size: cover;
    background-position: left;
  }
`;

const BannerContent = styled.div`
  position: relative;  
  z-index: 1;
  padding-top: 64px;
`;

const Title = styled(Typo.HeaderTwo)`
  font-size: 28px !important;
  color: ${props => props.theme.darkBlue} !important;
  font-weight: 600 !important;

  @media(max-width: 600px) {
    margin: 0;
  }
`;

const Subtitle = styled(Typo.Paragraph)`
  font-size: 18px !important;
  font-weight: 600 !important;
  color: ${props => props.theme.darkBlue} !important;
`;

const Intro = styled.div`
  margin-top: 28px;
  padding-left: 24px;
  border-left: 5px solid ${props => props.theme.greenLighter};

  @media(max-width: 600px) {
    padding:0px 16px;
  }
`;

const Text = styled(Typo.Paragraph)`
  font-size: 16px !important;
`;

const Bold = styled.span`
  font-weight: ${props => (props.weight ? props.weight : '500')};
  ${props => props.title && `
    color: ${props.theme.greenLighter};
    font-size: 20px;
  `}
`;

const Col = styled.div`
  width: 100%;
`;

const TitleContent = styled(Title)`
  font-size: 20px !important;
  @media(max-width: 600px) {
    margin: 28px 0;
  }
`;

const ContactUs = styled.div`
  margin-top: 60px;
  @media(max-width: 600px) {
    padding:0px 16px;
  }
`;

const TitleContactUs = styled(Typo.HeaderTwo)`
  margin: 4px 0;
`;

const RegisterButton = styled(Buttons.Button.OrangeButton)`
  width: 148px;
  margin: 32px 0px 0px;
  box-shadow: 0 3px 15px 0 ${props => props.theme.orange};
  cursor: pointer;

  @media(max-width: 600px) {
    margin-top: 14px;
  }
`;

const ContactButton = styled(Buttons.Button.TextButton)`
  width: 148px;
  margin: 24px 0px 0px;
  background: transparent;
  color: ${props => props.theme.orange};
  font-weight: 500;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px ${props => props.theme.orange};
`;

const TextContent = styled.div`
  @media(max-width: 600px) {
    padding:0px 16px;
  }
`;

const Desktop = styled.div`
  @media(max-width: 600px) {
    display: none;
  }
`;

const Mobile = styled.div`
  display: none;
  @media(max-width: 600px) {
    display: block;
  }
`;

const Influencer = () => {
  const { width } = useWindowSize();
  const isMobile = width < 768;
  const scrollName = isMobile ? 'register-mebile' : 'register-desktop';

  return (
    <div>
      <HeadTag
        title="Influencer - TakeMeTour"
        image="/static/images/Influencer/influencer_preview.jpg"
      />
      <Banner>
        <Container>
          <BannerContent>
            <Title>Be the new wave of influence!</Title>
            <Subtitle>Get sponsored to discover Thailand <br/>with a local friend.</Subtitle>
            <RegisterButton
              onClick={() => {
                scrollTo(scrollName, {
                  offset: -140,
                  duration: 500,
                  smooth: true,
                });
              }}
            >
              Apply now
            </RegisterButton>
          </BannerContent>
        </Container>
        <BannerOverlay />
      </Banner>
      <Container content>
        <Col>
          <Intro>
            <Text><Bold title>Are you an influencer who wants to share stories beyond the tourist attractions?</Bold> Then let locals show you the hidden gems and insider knowledge that will captivate your audience. <br /><br />At TakeMeTour, we are committed to connecting travelers and locals for the best authentic experience rooted in ethical and sustainable practices. With over 1000 selective private local tours in Thailand, and our recent expansion into Cambodia, Vietnam and the Philippines, we don’t plan on stopping.</Text>
          </Intro>
          <Detail />
          <TextContent>
            <TitleContent>What can we offer?</TitleContent>
            <Text>
              We want to show you the side of Thailand the guidebooks don’t tell you about. From cooking with locals to exploring hidden waterfalls, you will surely leave with unforgettable stories to share with your audiences and friends.<br /><br /> We are happy to sponsor you on our unique local tours. All you have to do is share your tour experience via your social media channels and blog. It’s that simple! <br /><br />If you are interested to work with us, please kindly fill in your information and we will get back to you asap.
            </Text>
            <TitleContent>How do we process?</TitleContent>
            <Text>
              After receiving your application, we will contact you back within 7 working days. If you do not hear back from us then, unfortunately, this means your submission was not successful. <br /><br />
              <Intro>
                <Text>
                  The evaluation criteria for the local tour sponsorship are as follows:<br /><br />
                  1. Nature of Content<br />
                  2. Website Traffic and Social Media Engagement<br />
                  3. Promoting Article<br />
                  4. Media in return
                </Text>
              </Intro>
              <br /><br />
              Please submit the application form before your travel date <br />around 2-3 weeks.
            </Text>
          </TextContent>
          <Mobile>
            <Element name="register-mebile" />
            <RehydrateComponent>
              <Register isMobile={isMobile} />
            </RehydrateComponent>
          </Mobile>
          <ContactUs>
            <TitleContactUs>Would like to talk?</TitleContactUs>
            <Text>
              Get in touch with us and we’ll get back to you as soon as possible.
            </Text>
            <a href="mailto:affiliate@takemetour.com"><ContactButton>Contact Us</ContactButton></a>
          </ContactUs>
        </Col>
        <Col>
          <Desktop>
            <Element name="register-desktop" />
            <RehydrateComponent>
              <Register isMobile={isMobile} />
            </RehydrateComponent>
          </Desktop>
        </Col>
      </Container>
    </div>
  );
};

export default Influencer;
